// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-primary{color:#00746b!important}.text-secondary{color:#01968a!important}.text-accent{color:#9c27b0!important}.text-info{color:#00cae3!important}.text-muted{color:#6c757d!important}.free-red{color:red}.text-15{font-size:15px}#app.v-application a{text-decoration:none;color:#00746b}", ""]);
// Exports
module.exports = exports;
